/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Sovereign_NameInputs */

const en_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Entity`)
};

const es_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const fr_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const de_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ja_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const zh_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ar_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const id_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entitas Sovereign`)
};

const it_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ru_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const pt_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

const ko_pricing_sovereign_name = /** @type {(inputs: Pricing_Sovereign_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign`)
};

/**
* | output |
* | --- |
* | "Sovereign Entity" |
*
* @param {Pricing_Sovereign_NameInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_sovereign_name = /** @type {((inputs?: Pricing_Sovereign_NameInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Sovereign_NameInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_sovereign_name(inputs)
	if (locale === "es") return es_pricing_sovereign_name(inputs)
	if (locale === "fr") return fr_pricing_sovereign_name(inputs)
	if (locale === "de") return de_pricing_sovereign_name(inputs)
	if (locale === "ja") return ja_pricing_sovereign_name(inputs)
	if (locale === "zh") return zh_pricing_sovereign_name(inputs)
	if (locale === "ar") return ar_pricing_sovereign_name(inputs)
	if (locale === "id") return id_pricing_sovereign_name(inputs)
	if (locale === "it") return it_pricing_sovereign_name(inputs)
	if (locale === "ru") return ru_pricing_sovereign_name(inputs)
	if (locale === "pt") return pt_pricing_sovereign_name(inputs)
	return ko_pricing_sovereign_name(inputs)
});